import Http from '../utils/axios'
const rt = '/api-zendai'
const user = '/user'
const operation = '/operation'
export default {
    /*--------全局接口-----------*/
    /*-------E端登录------*/
    getUserInfoList(params){
        return Http.post(`${rt}${user}/v1/e/userInfo/getUserInfoList`,params,true)
    },
    // 禁用启用账号
    changeStatus(params) {
        return Http.post(`${rt}${user}/v1/e/userInfo/updateStatus`, params, false)
    },
    /*------更新账号信息------*/
    updateInfo(params){
        return Http.post(`${rt}${user}/v1/e/userInfo/saveOrUpdate`,params, false)
    },
    /*------删除账号信息------*/
    delAccount(params){
        return Http.post(`${rt}${user}/v1/e/userInfo/deleteUser?userId=${params.userId}`, '', true)
    },
    /*------获取角色列表------*/
    getRoleList(params){
        return Http.post(`${rt}${user}/v1/e/role/findPage`,params,true)
    },
    // 新增和编辑角色
    setRoles(params) {
        return Http.post(`${rt}${user}/v1/e/role/saveOrUpdate`, params, false)
    },
    /*------获取账号详情------*/
    getUserInfoDetail(params){
        return Http.get(`${rt}${user}/v1/e/userInfo/getUserDetail`,params,true)
    },
    // 商场数据权限
    queryMallsAuth(userId) {
        return Http.get(`${rt}${user}/v1/e/mall/mallAuthoriList?userId=${userId}`, false, false)
    },
    // 角色数据权限
    queryRolesAuth(userId) {
        return Http.get(`${rt}${user}/v1/e/role/getUserAuthoriRole?userId=${userId}`, false, false)
    },
    // 取消权限
    cancelAuth(params) {
        return Http.post(`${rt}${user}/v1/e/privilege/cancelPrivilege`, params, false)
    },
    // 添加权限
    addAuth(params) {
        return Http.post(`${rt}${user}/v1/e/privilege/addPrivilege`, params, false)
    },
    // 根据角色名字查询角色
    queryRolesByRoleName(roleName) {
        return Http.get(`${rt}${user}/v1/e/role/getListByRoleName?roleName=${roleName}`, false, false)
    },
    // 用户确定授权角色
    setBindRole(params) {
        return Http.post(`${rt}${user}/v1/e/role/v1/e/role/userBingRole`, params, false)
    },
    // 用户移除角色权限
    setUnbindRole(params) {
        return Http.post(`${rt}${user}/v1/e/role/v1/e/role/userUnBingRole`, params, false)
    },
    // 权限授权
    setAuth(params) {
        return Http.post(`${rt}${user}/v1/e/privilege/addPrivilegeWithApplication`, params, false)
    },
    // 同步用户名称等基本信息 userGroupUser/updateStoreGroupUser
    updateStoreGroupUser(params) {
        return Http.get(`${rt}${operation}/v1/e/userGroupUser/updateStoreGroupUser`, params, false);    
        // return Http.post(`${posUrl}api-sce/e/noauth/tokenLogin`, params, false);    
    },
    // 同步角色名称等基本信息 userGroupUser/updateStoreGroupUserRoleName
    updateStoreGroupUserRoleName(params) {
        return Http.post(`${rt}${operation}/v1/e/userGroupUser/updateStoreGroupUserRoleName`, params, false);    
        // return Http.post(`${posUrl}api-sce/e/noauth/tokenLogin`, params, false);    
    },
    
    // 查询业态树-商品详情
    selectShopTreeList(params) {
        return Http.post(`/api-zendai/investment/e/category/selectShopTreeList`, params, false);    
    },
    // 用户添加租户级别权限点
    addShopPrivilege(params) {
        return Http.post(`/api-zendai/user/v1/e/privilege/addShopPrivilege`, params, false);
    },
    // 查询楼栋树-商户详情
    buildingListTree(params) {
        return Http.post(`/api-zendai/investment/e/mallManage/buildingListTree`, params, false);    
    },
}
